module.exports = __webpack_public_path__ + "static/media/placeholder.b6cdf5b5.svg";